//@ts-check

const ResponseTemplates = {
	deleteSuccess: 'gdpr_account_delete_success_popup',
	actionError: 'gdpr_account_action_error_popup',
	requestSuccess: 'gdpr_account_request_success_popup'
}

const SettingsCancelTypes = {
	guest: 0,
	member: 1
};

const OptionValues = [
	'Select an option',
	'I want to transfer my data to me or a third-party',
	'I want to rectify incorrect data this site has about me',
	'I want to object to the way this site is using my personal information'
];

const PopupWidgetClasses = {
	settings: 'GDPR_SettingsPopup',
	actionResponse: 'GDPR_AccountActionResponse',
	deleteAccount: 'GDPR_AccountDeleteConfirm',
	deleteAccountFinal: 'GDPR_AccountDeleteFinal',
	rulesActions: 'GDPR_AccountRulesActions',
	attentionActions: 'GDPR_AccountAttentionActions'
}

/**
 * 
 * @param {HTMLButtonElement} button 
 */
const changeButtonState = (button, newText) => {
	const text = button.innerText;
	button.innerText = newText;
	button.disabled = true;

	return () => {
		button.disabled = false;
		button.innerText = text;
	};
}

exports.SettingsCancelTypes = SettingsCancelTypes;
exports.PopupWidgetClasses = PopupWidgetClasses;

/**
 * 
 * @param {Fox} fox 
 */
exports.factory = (fox) => {
	// settings popup
	fox.registerWidget(PopupWidgetClasses.settings, {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'gdpr_settings_popup',
				onOkPress: (...args) => this.sumbitForm(...args),
				onCancelPress: (...args) => this.onCancel(...args),
				dialog:{
					close: (event) => {
					 	if (event.currentTarget !== undefined && event.currentTarget.id != 'on-success') this.resolve(false);
					}
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					deletePopup: {
						widget: PopupWidgetClasses.deleteAccount,
						contentTemplate: 'gdpr_account_delete_confirm_after_login_popup'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						valuePostProcessing: [
							(value) => value === 'on' ? 1 : 0
						]
					}
				},
				handleWom: {
					formValidation: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: (infos, form) => infos.forEach(({ field, result }) => {
							const element = form.getElement(field);
							
							element.nodes.forEach((node) => {
								const label = node.parentNode.parentNode;

								if (label) {
									return !result ?
										label.classList.add('error') :
										label.classList.remove('error');
								}
							});
						})
					}
				}
			});

			this.callParent('configure', arguments);
		},

		showForMember() {
			return this.show(SettingsCancelTypes.member).then((result) => {
				if (result) {
					const api = this.getApi('saveConsentFlags', {
						method: 'consent.provideBulk',
						httpMethod: 'post'
					});

					api.psend({
						aliases: Object.keys(result).reduce((obj, key) => {
							obj[`${key.replace('consent_', '')}`] = result[key];

							return obj;
						}, {})
					});
				}

				return result;
			});
		},

		show(type = SettingsCancelTypes.guest, ...args) {
			return this.callParent('show', args).then((result) => {
				if (!result) {
					if (type === SettingsCancelTypes.guest) {
						return this.rwom1('#actionPopup').show(
							ResponseTemplates.actionError,
							'Your request cannot be completed until you approve the Personal Data processing rules.'
						).then(() => false);
					} else if (type === SettingsCancelTypes.member) {
						return this.rwom1('#deletePopup').show().then((result) => {
							if (result === false) {
								return this.showForMember();
							}

							return result;
						});
					}
				}

				return result;
			});
		},

		sumbitForm(button) {
			return this.rwom1('#form').submit().then((values) => {
				if (values !== false) {
					this.hide();
					return values;
				}

				return null;
			});
		},

		onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');

	// account action response popup
	fox.registerWidget(PopupWidgetClasses.actionResponse, {
		configure() {
			this.registerOptions('', {
				additionalClasses: 'gdpr-small',
				hideOnOkPressed: true,
				onOkPress: (button, ...args) => {
					if (this.getOption('hideOnOkPressed')) {
						this.hide();
					}

					return fox.Promise.resolve(button);
				},
			});

			this.callParent('configure', arguments);
		},

		show(template, text = '', ...args) {
			const content = this.rwom1('#content');
			content.setOption('template', template);
			content.setTemplateOptions('text', text);

			content.render();

			return this.callParent('show', args);
		}
	}, 'GDPR_BasePopup');

	// account delete final popup
	fox.registerWidget(PopupWidgetClasses.deleteAccountFinal, {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_final_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: (...args) => this.removeAccount(...args),
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse,
						hideOnOkPressed: false
					}
				}
			});

			this.callParent('configure', arguments);
		},

		removeAccount(button) {
			const deleteApi = this.getApi('deleteApi', {
				method: !!fox.getEnv('site.id') ? 'user.deleteAccount' : 'client.delete',
				httpMethod: !!fox.getEnv('site.id') ? 'get' : 'post'
			});
			const actionPopup = this.rwom1('#actionPopup');

			const restoreButtonState = changeButtonState(button, 'deleting...');
			return deleteApi.psend().then((resp) => {
				restoreButtonState();
				this.hide();
				
				return actionPopup.show(ResponseTemplates.deleteSuccess)
					.then(
						/** @param {HTMLButtonElement} button */
						(button) => {
							const restoreButtonState = changeButtonState(button, 'please wait...')
							return this.getWom().getRoot().logout().then(() => restoreButtonState);
						}
					)
					.then((restoreButtonState) => restoreButtonState());
			}).catch((err) => {
				restoreButtonState();
				this.hide();
				return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message)
					.then(() => false);
			});
		}
	}, 'GDPR_BasePopup');

	// account delete confirm popup
	fox.registerWidget(PopupWidgetClasses.deleteAccount, {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_confirm_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: (...args) => this.rwom1('#deleteAccount').show(...args),
				widgets: {
					deleteAccount: {
						widget: PopupWidgetClasses.deleteAccountFinal
					}
				}
			});

			this.callParent('configure', arguments);
		},
	}, 'GDPR_BasePopup');

	// account rules manipulation popup
	fox.registerWidget(PopupWidgetClasses.rulesActions, {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'gdpr_account_rules_action_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: (...args) => this.sumbitForm(...args),
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					actions: {
						widget: 'Control_Select',
						embed: {
							widget: '@parent #content'
						},
						'!embed.container': '#actions-select',
						autoRender: true,
						select: {
							options: OptionValues.map((value, idx) => ({
								title: value,
								selected: idx === 0,
								disabled: idx === 0,
								value: idx
							})),
							attributes: {
								name: 'actions'
							}
						}
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						elements: {
							actions: {
								womContainer: '@parent #actions',
								validators: [
									(value) => ({ result: Number(value) !== 0 })
								]
							}
						}
					},
				},
				handleWom: {
					changed: {
						widget: '#form',
						event: 'change',
						callback: ({ field, value }) => {
							if (field === 'actions') {
								this._bindData.emptyValue = value === OptionValues[0];

								this._center();
							}
						}
					},
					validation: {
						widget: '#form',
						event: ['form_not_valid', 'form_valid'],
						callback: (infos, form) => infos.forEach(({ field, result }) => {
							if (field === 'actions') {
								const [ select ] = form.getElement(field).getNodes();
								const container = select.parentNode;

								if (!result) {
									return container.classList.add('error');
								}

								return container.classList.remove('error');
							}
						})
					}
				}
			});

			this.callParent('configure', arguments);
		},

		prepareEmbeddedWidgets() {
			this._bindData = {
				emptyValue: true
			};

			this.rwom1('#content').bindTemplateVariables(this._bindData, ['emptyValue']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

		sumbitForm(button) {
			const sendApi = this.getApi('sendApi', {
				method: 'site.gdprRequest',
				encodePost: true,
				httpMethod: 'post'
			});
			const actionPopup = this.rwom1('#actionPopup');
			const form = this.rwom1('#form');

			return form.submit().then((values) => {
				if (values === false) {
					return null;
				}

				const restoreButtonState = changeButtonState(button, 'submiting...');

				return sendApi.psend({
					subject: OptionValues[values.actions],
					comment: values.comment,
					optionAlias: values.actions === '1' ? 'transferData': false
				}).then((resp) => {
					restoreButtonState();
					this._resetForm();
					this.hide();
					return actionPopup.show(ResponseTemplates.requestSuccess)
						.then(() => true);
				}).catch((err) => {
					restoreButtonState();
					this._resetForm();
					this.hide();
					return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message)
						.then(() => false);
				});
			});
		},

		_resetForm() {
			const form = this.rwom1('#form');

			form.setValue('actions', '0');
			form.setValue('comment', '');

			form.getElement('actions').womContainer.change();
		}
	}, 'GDPR_BasePopup');

	fox.registerWidget(PopupWidgetClasses.attentionActions, {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'gdpr_account_attention_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: (...args) => this.onCancel(),
				dialog: {
					close: () => this.onCancel()
				},
			}),

			this.callParent('configure', arguments);
		},
		onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/widget/popups.es.js